// extracted by mini-css-extract-plugin
export var bounce = "plan-card-module--bounce--yMVVQ";
export var chosen = "plan-card-module--chosen--Zv5Qi";
export var container = "plan-card-module--container---pgmE";
export var lock = "plan-card-module--lock--GeL1p";
export var ordered = "plan-card-module--ordered--lGoDX";
export var title = "plan-card-module--title--kUcci";